import Vue from 'vue';
import mixin from './../../../../mixins/mixin';

export default {
    data() {
        return {
            error: null,
            success: false,
            loading: false,
            id: false,
            type: "",
            contract: {
                content: "",
                name: "",
                thumbnail: "",

            },
            content: "",
            thumbnail: "",
        };
    },
    components: {
        VLayout: require('layouts/default/default.vue'),
        VPanel: require('components/panel/panel.vue'),
        Redactor : require('components/redactor/redactor.vue'),
        VLoading : require('components/loading/loading.vue')
    },
    mixins:[mixin],
    mounted() {
        var vm = this;
        vm.loading = true;
        vm.type = vm.$route.params.type;

        if(vm.$route.params.id && vm.$route.params.id != 'create'){
            let id = vm.$route.params.id;
            vm.fetch_contract(id);
            vm.id = id;
        }else{
            vm.loading = false;
        }

    },
    methods: {
        fetch_contract(id){
            var vm = this;
            //TODO Create Service for get templates
            Vue.$http.get('/templates/'+id)
                .then((response) => {
                if (response && response.status === 200) {
                vm.contract = response.data.contract;
                vm.loading = false;
            }
            })
            .catch((error) => {
                    console.log(error);
            });
        },
        update_contract(){
            let vm = this;
            let data =  {};
            let id = vm.$route.params.id;
            data.content =  $('#redactor-uuid-0').html();
            data.thumbnail =  vm.contract.thumbnail;
            data.name =  vm.contract.name;
            vm.loading = true;
            //TODO Create Service for update templates
            Vue.$http.put('/templates/'+id, data).then((response) => {
                if (response && response.status === 200) {
                    //vm.contract = response.data.contract;
                    toastr.success(response.data.msg);
                    vm.loading = false;
                    vm.goBack();
                }
            }).catch((error) => {
                if (error.response) {
                    vm.showToasterError(error);
                    vm.loading = false;
                }
            });
        },
        goBack(){
            window.history.back()
        },
        create_template(){
            let vm = this;
            let data =  {};
            data.content =  $('#redactor-uuid-0').html();
            data.thumbnail =  vm.contract.thumbnail;
            data.name =  vm.contract.name;
            data.user_id =  null;
            data.type =  vm.type;
            vm.loading = true;
            //TODO Create Service for create templates
            Vue.$http.post('/templates', data).then((response) => {
                if (response && response.status === 200) {
                    //vm.contract = response.data.contract;
                    toastr.success(response.data.msg);
                    vm.loading = false;
                    vm.goBack();
                }
            }).catch((error) => {
                if (error.response) {
                vm.showToasterError(error);
                vm.loading = false;
                }
            });
        },
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/template/edit/edit.js